import { useEffect, useState } from "react";
import api from "../lib/api";
import SectionHeading from "../components/SectionHeading";
import { ArrowRight } from "lucide-react";

const CATS = ["All", "Market Trends", "Buying Guide", "Investment", "Home Loans", "Legal", "RERA", "Plots", "Commercial Real Estate", "NRI Property"];

export default function Insights() {
  const [articles, setArticles] = useState([]);
  const [cat, setCat] = useState("All");
  useEffect(() => { api.articles().then(setArticles).catch(() => {}); }, []);
  const filtered = articles.filter((a) => cat === "All" || a.category === cat);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
      <SectionHeading eyebrow="Editorial" title="Real Estate Insights"
        subtitle="Market trends, buying guides and expert perspectives for Indian real estate." />
      <div className="flex gap-2 overflow-x-auto no-scrollbar mb-8">
        {CATS.map((c) => (
          <button key={c} onClick={() => setCat(c)} data-testid={`insight-cat-${c.toLowerCase().replace(/\s/g, "-")}`}
            className={`px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap border transition-colors ${cat === c ? "bg-pbs-purple text-white border-pbs-purple" : "bg-white text-pbs-grey border-pbs-line hover:border-pbs-purple"}`}>{c}</button>
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filtered.map((a) => (
          <article key={a.slug} data-testid={`article-${a.slug}`} className="bg-white rounded-2xl border border-pbs-line overflow-hidden pbs-shadow hover:pbs-shadow-hover transition-shadow group cursor-pointer">
            <div className="aspect-[16/9] overflow-hidden"><img src={a.image} alt={a.title} loading="lazy" className="w-full h-full object-cover zoom-img" /></div>
            <div className="p-5">
              <span className="text-[11px] font-bold uppercase tracking-wider text-pbs-magenta">{a.category}</span>
              <h3 className="mt-1.5 font-bold text-lg text-pbs-dark leading-snug group-hover:text-pbs-purple transition-colors">{a.title}</h3>
              <p className="mt-2 text-sm text-pbs-grey line-clamp-2">{a.summary}</p>
              <div className="mt-3 pt-3 border-t border-pbs-line flex items-center justify-between text-xs text-pbs-grey">
                <span>{a.author} · {a.date}</span>
                <span className="text-pbs-purple font-semibold flex items-center gap-1">{a.read_time} <ArrowRight size={12} /></span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
